export default __webpack_public_path__ + "static/media/waste-water.73e2404a.webp";